import $ from 'jquery';
import Swup from 'swup';
import Alpine from 'alpinejs';
import 'regenerator-runtime/runtime';

// Import Swiper and required modules
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const swup = new Swup(options);

// Events
swup.hooks.on('content:replace', init);


window.Alpine = Alpine
Alpine.start();

// Variables 
const $d = $(document),
  $w = $(window);

const options = {
  plugins: [
    // new SwupScrollPlugin(),
    // new SwupBodyClassPlugin()
  ],
  linkSelector:
    'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not([target="_blank"]), ' +
    'a[href^="/"]:not([data-no-swup]):not([target="_blank"]), ' +
    'a[href^="#"]:not([data-no-swup]):not([target="_blank"])',
};

// const swup = new Swup(options);

// // Swup Hooks to Replace Events
// swup.hooks.after('page:view', () => {
//   init(); // Reinitialize your custom logic
//   scrollReveal('.out'); // Example function for animations
//   console.log('Swup: New content replaced and initialized');
// });


// make vanilla
// Floorplans Class
class Floorplans {
  toggleTab(event) {
    event.preventDefault();
    l('toggledTab');
    $('.floorplans_nav a').removeClass('active');
    $(this).addClass('active');
    let index = $(this).parent().index();

    $('.floorplans_view').removeClass('active');
    $('.floorplans_view').eq(index).addClass('active');
  }

  toggleFloor(event) {
    event.preventDefault();
    l('toggledFloor');

    $('.floorplans_view.active').find('.floorplans_floors a').removeClass('active');
    $(this).addClass('active');
    let hash = $(this).attr('href');
    let hashClass = '[href="' + hash + '"]';
    $(this).closest('.floorplans_view.active').find('.floorplans_main a').removeClass('active');
    $(hashClass).addClass('active');
  }
}

let fp = new Floorplans();


// make alpine
// Event Listeners
$d.on('click', '.cookie_btn', setCookie)
  // .on('click', '.more-btn', showBio)
  .on('click', '.team_member_bio .close', hideBio)
  .on('click', '.burger', navBar)
  .on('click', '.nav a', navBar)
  .on('click', '.home-link', navBar)
  .on('click', '[href="#video"]', showVideoOverlay)
  .on('click', '.split_video a', showVideoOverlay)
  .on('click', '.split_text a', showVideoOverlay)
  .on('click', '.video_close', hideVideoOverlay)
  .on('click', '.floorplans_nav a', fp.toggleTab)
  .on('click', '.split_opengallery', showGallery)
  .on('click', '.floorplans_prev', prevImage)
  .on('click', '.floorplans_next', nextImage)
  .on('click', 'a[href="#floorplangallery"]', showFloorplanGallery)
  .on('click', '.split_close', hideGallery)
  .on('click', '.floorplans_floors a', fp.toggleFloor)
  .on('mouseenter', '.nav a[href$="/developments"]', showNavDropdown)
  .on('mouseleave', '.nav_dropdown', hideNavDropdown);


// Functions 
function l(m) { console.log(m); }

// make alpine
function showNavDropdown() {
  if (!$('.nav_dropdown').hasClass('active')) {
    $('.nav_dropdown').addClass('active');
    l('showNavDropdown');
  };
}

// make alpine
function hideNavDropdown() {
  if ($('.nav_dropdown').hasClass('active')) {
    $('.nav_dropdown').removeClass('active');
    l('hideNavDropdown');
  };
}

// make vanilla
function prevImage(event) {
  l('prevImage');
  event.preventDefault();
}

// make vanilla
function nextImage(event) {
  l('nextImage');
  event.preventDefault();

}

// make vanilla
function showGallery(event) {
  event.preventDefault();
  l('showGallery');
  $(this).closest('.split').next().addClass('active');
}

// make vanilla
function hideGallery(event) {
  event.preventDefault();
  l('showGallery');
  $(this).closest('.split_gallery').removeClass('active');
  $(this).closest('.floorplans_gallery').removeClass('active');
}

// make vanilla
function showFloorplanGallery(event) {
  event.preventDefault();
  l('showFloorplanGallery');
  $(this).closest('.floorplans').next().addClass('active');


}

// make vanilla/remove and make alpine
function showVideoOverlay() {
  l('showVideoOverlay');
  $(this).parent().siblings('.video_overlay').addClass('active');
}

// make vanilla/remove and make alpine
function hideVideoOverlay() {
  l('hideVideoOverlay');
  $(this).parent().removeClass('active');
}


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  checkCookie();
  init();
  getInnerHeight();
  scrollReveal('.out');
  $(window).trigger('resize');
  // loadSplides();
});

var lastScrollTop = 0;

// make vanilla
$(window).on('scroll', function () {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function () {

      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $('.header').addClass('scrolled');
      } else {
        $('.header').removeClass('scrolled');
      }
      lastScrollTop = st;

      toggleLogoType();
      // checkBgColor('.page > section', 25);
      playVideo('video', 250);
      scrollReveal('.out');
      scrollTimeout = null;
    }, throttle);
  }
});


// make vanilla
var menuTimeout;
$(window).on('mousemove', mouseHandler);

function mouseHandler(e) {

  var st = $(window).scrollTop();
  var mouseTop = e.pageY - st;

  if (st != 0) {

    if (mouseTop < 100 || $('.header').is(':hover')) {
      clearTimeout(menuTimeout);
      menuTimeout = null;
      $('.header').removeClass('scrolled');
    } else if (menuTimeout === null) {
      menuTimeout = setTimeout($('.header').addClass('scrolled'), 500);
    }
  }
}


window.addEventListener('resize', () => {
  getInnerHeight();
  scrollReveal('.out');
});



let floorplanswiper;

function init() {
  l('👍');
  highlightActive();
  lazyImages();
  // checkBgColor('.page > section', 0);
  // loadAllSliders();
}


// function loadAllSliders() {
//   const splitSwiper = new Swiper('.split_gallery .swiper-container', {
//     // Optional parameters
//     // direction: 'vertical',
//     loop: false,
//     centeredSlides: true,
//     // Navigation arrows\
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },

//   });



//   floorplanswiper = new Swiper('.floorplans_gallery .swiper-container', {
//     // Optional parameters
//     // direction: 'vertical',
//     loop: false,
//     centeredSlides: true,
//     // Navigation arrows\
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },

//     on: {
//       init: function (e) {
//       },
//     },

//   });


//   const bannerImageSwiper = new Swiper('#bannerImageSwiper', {
//     preloadImages: true,
//     speed: 1000,
//     loop: true,
//     autoplay: {
//       delay: 4500,
//     },
//     updateOnImagesReady: true,
//   });



//   const bannerSwiper = new Swiper('.swiper-container.banner_swiper', {
//     centeredSlides: true,
//     preloadImages: true,
//     speed: 1000,
//     loop: true,
//     autoplay: {
//       delay: 4500,
//     },
//     updateOnImagesReady: true,
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     on: {
//       init: function (e) {
//         console.log('swiper initialized');
//         // bannerSwiper.slideNext();
//         // e.params.autoplay = 1000;
//       },
//       imagesReady: function (e) {
//         console.log('images ready.'); // this doesn't work
//         // console.log(e);
//         // e.params.autoplay = 1000;
//       }
//     },
//   });


//   const projectSwiper = new Swiper('.swiper-container.project_swiper', {
//     centeredSlides: true,
//     preloadImages: true,
//     speed: 1000,
//     loop: true,
//     autoplay: {
//       delay: 5500,
//     },
//     updateOnImagesReady: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     on: {
//       init: function (e) {
//         console.log('swiper initialized');
//         // bannerSwiper.slideNext;
//         // e.params.autoplay = 1000;
//       },
//       imagesReady: function (e) {
//         console.log('images ready.'); // this doesn't work
//         console.log(e);
//         // e.params.autoplay = 1000;
//       }
//     },
//   });
// }

function highlightActive() {
  $('.nav a.active').removeClass('active');
  $('a[href*="' + window.location.pathname + '"]').addClass('active');
  if (window.location.pathname == '/') {
    clearNav();
  }
}



function clearNav() {
  $('.nav a.active').removeClass('active');
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  $('.cookie').addClass('hidden');
}

function checkCookie() {
  l('check cookie');
  if (document.cookie.indexOf('cookie-note=1') !== -1) {
    $('.cookie').addClass('hidden');
  } else {
    $('.cookie').removeClass('hidden');
  }

  if (document.cookie.indexOf('cookie-form=1') !== -1) {
    $('.overlay').addClass('hidden');
  } else {
    $('.overlay').removeClass('hidden');
  }

}

function lazyImages() {

  l('lazyImages');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.add("animate");
          lazyImageObserver.unobserve(lazyImage);
          throttle(loadIsotope, 200);
        }
      });
    });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
}

function hideBio(event) {
  if (event) {
    event.preventDefault();
  }

  $('.more-btn').removeClass('animOn');
  $('.team_member_bio').removeClass('active');
  $('.team_member').removeClass('active');
}


function showBio(event) {

  event.preventDefault();

  hideBio();

  let $btnPos = $(this).offset(),
    $container = $(this).parent().parent().parent(),
    $containerPos = $(this).parent().parent().offset(),
    $bio = $(this).parent().parent().next(),
    // top = $container.top, //$btnPos.top - $containerPos.top,
    left = $btnPos.left - $containerPos.left;

  $container.addClass('active');

  let mobile = window.matchMedia('(max-width: 600px)');

  if (mobile) {
    left = left + 20;
    $bio
      .addClass('active')
      .css({
        'left': left
      });

  } else {

    $bio.addClass('active')
      .css({
        // 'top' : top,
        'left': left
      });
  }

  if (!$(this).hasClass('animOn')) {
    $(this).addClass('animOn');
  } else {
    $(this).removeClass('animOn');
  }

}


function navBar() {
  if ($(this).hasClass('home-link')) {
    $('.header').removeClass('active');
    l('true');
  } else {
    if ($('.header').hasClass('active')) {
      $('.header').removeClass('active');
    } else {
      $('.header').addClass('active');
    }
  }
}

const fetchArticles = async () => {
  const element = document.querySelector('.articles');
  const button = document.querySelector('.load-more');
  let page = parseInt(element.getAttribute('data-page'));
  let url = 'news.json/page:2';

  try {
    const response = await fetch(url);
    const {
      html,
      more
    } = await response.json();
    button.hidden = !more;
    element.innerHTML += html;
    page++;
  } catch (error) {
    console.log('Fetch error: ', error);
  }
}

on('body', 'click', '.load-more', function (e) {
  fetchArticles();
});


function on(elSelector, eventName, selector, fn) {
  var element = document.querySelector(elSelector);

  element.addEventListener(eventName, function (event) {
    var possibleTargets = element.querySelectorAll(selector);
    var target = event.target;

    for (var i = 0, l = possibleTargets.length; i < l; i++) {
      var el = target;
      var p = possibleTargets[i];

      while (el && el !== element) {
        if (el === p) {
          return fn.call(p, event);
        }
        el = el.parentNode;
      }
    }
  });
}



var scrollTimeout;
var throttle = 100;

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


function getInnerHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}


function scrollReveal(element) {
  $(element).each(function (i) {
    var element = this;
    if (isElementInViewport(element)) {
      setTimeout(function () {
        element.classList.add('is-visible');
      }, 30 * i);
    }
  });
}


function isElementInViewport(el) {

  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();

  return (
    (rect.top <= 0 &&
      rect.bottom >= 0) ||
    (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
    (rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );

}




function lightOrDark(color) {
  if (color != null) {
    color = +("0x" + color.slice(1).replace(
      color.length < 5 && /./g, '$&$&'
    ));


    var r = color >> 16,
      g = color >> 8 & 255,
      b = color & 255;

    var hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    if (hsp > 127.5) {
      return 'light';
    }
    else {

      return 'dark';
    }
  }
}






function playVideo(element, distance) {
  $(element).each(function () {
    var itemOffset = Math.abs($(this).offset().top),
      viewableOffset = itemOffset - $(window).scrollTop();

    if (viewableOffset <= distance) {
      $(this)[0].play();
    } else {
      $(this)[0].pause();
    }
  });
}



function checkBgColor(element, distance) {
  $(element).each(function () {
    var itemOffset = Math.abs($(this).offset().top),
      viewableOffset = itemOffset - $(window).scrollTop(),
      bgColor = $(this).data('color');


    if (viewableOffset <= distance) {
      if (lightOrDark(bgColor) == 'light') {
        $('header').removeClass('dark');
        $('header').addClass('light');
      } else {
        $('header').removeClass('light');
        $('header').addClass('dark');
      }
    }
  });
}



function toggleLogoType() {
  var scroll = $(window).scrollTop();

  if (scroll >= 150) {
    $('.logo_type').removeClass('is-visible');
    $('.logo_type').removeClass('out');

  } else {
    $('.header').removeClass('scrolled');
    $('.logo_type').removeClass('is-visible');
    $('.logo_type').removeClass('out');
  }
}

// function loadSplides() {

//   var elms = document.getElementsByClassName('splide');

//   if (elms.length != 0) {
//     for (var i = 0; i < elms.length; i++) {
//       if (elms[i].parentNode.classList.contains('banner')) {
//         console.log('many')
//         new Splide(elms[i], {
//           type: 'loop',
//           padding: '0rem',
//           pagination: false,
//           gap: '1rem',
//           perPage: 3,
//           breakpoints: {
//             640: {
//               perPage: 1,
//               destroy: true
//             },
//           },
//           autoWidth: true,
//           focus: 0,
//           omitEnd: true,

//         }).mount();

//       } else {
//         console.log('single')
//         new Splide(elms[i], {
//           type: 'loop',
//           padding: '0rem',
//           pagination: true
//         }).on('pagination:mounted', function (data) {
//           console.log('pagination mounted');
//           console.log(data.items);
//           data.list.classList.add('splide__pagination--custom');
//           data.items.forEach(function (item) {
//             item.button.textContent = String(item.page + 1);
//           });
//         }).mount();

//       }
//     }
//   }
// }